import {
  DataType,
  isSelectableChartType,
  resolveDataType,
} from '@revelio/core';

import type { SecondaryDimensionValues } from '../types/dimension';
import type { PlotOptions, TableColumnConfig } from '../types/item';
import type { MetricValues } from '../types/metric';

const isTemporal = (plot: PlotOptions): boolean => {
  const { chartType, secondaryDimension, dimensionSource } = plot;
  const metric = plot.defaultMetricOptions?.[0];
  if (metric === undefined || !isSelectableChartType(chartType)) return false;

  const resolution = resolveDataType(
    chartType,
    metric,
    secondaryDimension,
    dimensionSource
  );
  return (
    resolution.compatible &&
    (resolution.resolvedDataType === DataType.TIMESERIES ||
      resolution.resolvedDataType === DataType.BREAKDOWN_TIMESERIES)
  );
};

export const dimensionColumn = (
  dimension: SecondaryDimensionValues,
  id = `dimension:${dimension}`
): TableColumnConfig => ({ id, kind: 'dimension', dimension });

export const variableColumn = (metric: MetricValues): TableColumnConfig => ({
  id: `variable:${metric}`,
  kind: 'variable',
  metric,
});

/** TODO: remove when all charts support tableColumns */
export const getPlotTableColumns = (
  plot: PlotOptions | undefined,
  entityDimension: SecondaryDimensionValues
): TableColumnConfig[] => {
  if (!plot) return [];
  if (plot.tableColumns?.length) return plot.tableColumns;

  const { dimensionSource = 'primary', secondaryDimension } = plot;
  const dimensions = new Set<SecondaryDimensionValues>();
  dimensions.add(
    dimensionSource === 'primary' ? entityDimension : dimensionSource
  );
  if (secondaryDimension) dimensions.add(secondaryDimension);
  if (isTemporal(plot)) dimensions.add('timeseries');

  return [
    ...[...dimensions].map((dimension) => dimensionColumn(dimension)),
    ...(plot.defaultMetricOptions ?? []).map(variableColumn),
  ];
};
